import { render, staticRenderFns } from "./language_toggler.vue?vue&type=template&id=23598cde&scoped=true&"
import script from "./language_toggler.vue?vue&type=script&lang=js&"
export * from "./language_toggler.vue?vue&type=script&lang=js&"
import style0 from "./language_toggler.vue?vue&type=style&index=0&id=23598cde&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23598cde",
  null
  
)

export default component.exports